import type { FetchTicketResponse } from "src/api/models";
import type { MenuItem } from "../types";

export function createDatePickerMenuItem(
  ticket: FetchTicketResponse,
  event: MouseEvent,
  handlers: {
    showDatePicker: (event: MouseEvent) => void;
  }
): MenuItem {
  return {
    label: "Change Planned Date",
    icon: "pi pi-calendar",
    command: () => handlers.showDatePicker(event)
  };
}
